import { Grid, Typography } from "@material-ui/core";
import React from "react";
import FormikTextField from "../../Base/Components/FormikTextField";
import NameFields from "../../Base/Components/NameFields";

export default function EditProfile({ nestedFormPrefix }) {
  return (
    <>
      <Typography variant="h3" className="h3-header" style={{ margin: "1rem 0 0.5rem 0" }}>
        Contact information
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <NameFields namePrefix={nestedFormPrefix ? nestedFormPrefix + "." : ""} />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormikTextField
            name={(nestedFormPrefix ? nestedFormPrefix + "." : "") + "email"}
            label="Email Address"
            type="email"
            maxLength={255}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormikTextField
            name={(nestedFormPrefix ? nestedFormPrefix + "." : "") + "phone"}
            label="Phone Number"
            type="tel"
            maxLength={50}
          />
        </Grid>
      </Grid>
      <Typography variant="h3" className="h3-header" style={{ margin: "1rem 0 0.5rem 0" }}>
        Mailing Address
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormikTextField
            name={(nestedFormPrefix ? nestedFormPrefix + "." : "") + "streetAddress1"}
            label="Street Address 1"
            maxLength={100}
          />
        </Grid>
        <Grid item xs={12}>
          <FormikTextField
            name={(nestedFormPrefix ? nestedFormPrefix + "." : "") + "streetAddress2"}
            label="Street Address 2"
            maxLength={100}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormikTextField
            name={(nestedFormPrefix ? nestedFormPrefix + "." : "") + "city"}
            label="City"
            maxLength={100}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormikTextField
            name={(nestedFormPrefix ? nestedFormPrefix + "." : "") + "state"}
            label="State"
            maxLength={50}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormikTextField
            name={(nestedFormPrefix ? nestedFormPrefix + "." : "") + "zipCode"}
            label="ZIP Code"
            maxLength={10}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormikTextField
            name={(nestedFormPrefix ? nestedFormPrefix + "." : "") + "country"}
            label="Country"
            maxLength={50}
          />
        </Grid>
      </Grid>
    </>
  );
}
